import React from 'react';
import IntroWidget from '../../../../widgets/IntroWidget/IntroWidget';
import NewsWidget from '../../components/NewsWidget/NewsWidget';
import StatisticsChartWidget from '../../../../widgets/StatisticsChartWidget/StatisticsChartWidget';
import SummaryWidget from '../../../../widgets/SummaryWidget/SummaryWidget';
import PersonalManagerWidget from '../../../../widgets/PersonalManagerWidget/PersonalManagerWidget';
import StoreWidget from '../../../../widgets/StroreWidget/StoreWidget';
import OffersWidget from '../../widgets/OffersWidget/OffersWidget';

export const items = {
  additional: [
    {
      id: 20,
      title: 'start',
      localStorageName: 'IntroWidget',
      collapsing: true,
      component: <IntroWidget key="20" />,
    },
  ],
  main: [
    {
      id: 1,
      title: 'news',
      localStorageName: 'NewsWidget',
      collapsing: true,
      component: <NewsWidget key="1" />,
    },

    {
      id: 2,
      title: 'statistics',
      localStorageName: 'StatisticsChartWidget',
      collapsing: true,
      component: <StatisticsChartWidget key="2" />,
    },

    // {
    //     id: 3,
    //     title: 'recommended-offers',
    //     localStorageName: 'RecommendedOffersWidget',
    //     collapsing: true,
    //     component: <RecommendedOffersWidget3 key="3" />,
    // },
    {
      id: 3,
      title: 'offers',
      localStorageName: 'OffersWidget',
      collapsing: true,
      component: <OffersWidget key="3" />,
    },
  ],
  widgets: [
    {
      id: 10,
      title: 'summary',
      localStorageName: 'SummaryWidget',
      collapsing: true,
      component: <SummaryWidget key="10" />,
    },

    //   {
    //       id: 11,
    //       title: 'manager',
    //       localStorageName: 'PersonalManagerWidget',
    //       collapsing: true,
    //       component: <PersonalManagerWidget key="11" />,
    //   },

    // {
    //     id: 12,
    //     title: 'new-offers',
    //     localStorageName: 'NewOffersWidget',
    //     collapsing: true,
    //     component: <NewOffersWidget key="12" />,
    // },

    // {
    //     id: 13,
    //     title: 'referrals-widget',
    //     localStorageName: 'SummaryWidget',
    //     collapsing: true,
    //     component: <ReferralsWidget key="13" />,
    // },

    {
      id: 14,
      title: 'store',
      localStorageName: 'StoreWidget',
      collapsing: true,
      component: <StoreWidget key="14" />,
    },
  ],
};
